import { useCallback, useRef } from "react";
import { Button, Modal } from "@ttc3k/trekker";
import { Box, Flex } from "styled-system/jsx";
import { OpenNewWindow } from "iconoir-react";
import { useTranslation } from "react-i18next";
import { ReservationDetails } from "../ReservationDetails/ReservationDetails";

type OrderDetailModalProps = {
  orderId: string | null;
  open: boolean;
  onClose: () => void;
};

export const OrderDetailModal = ({
  orderId,
  open,
  onClose,
}: OrderDetailModalProps) => {
  const { t } = useTranslation("core");
  const lastOrderIdRef = useRef<string | null>(null);

  if (orderId) {
    lastOrderIdRef.current = orderId;
  }

  const displayOrderId = orderId ?? lastOrderIdRef.current;

  const handleOpenOrderPage = useCallback(() => {
    if (displayOrderId) {
      window.open(`/order/${displayOrderId}`, "_blank");
    }
  }, [displayOrderId]);

  if (!displayOrderId) return null;

  return (
    <Modal
      open={open}
      onOpenChange={onClose}
      closeTriggerVisual="light"
      placement="rightPane"
      portal
    >
      <Flex
        flexDir="column"
        pt="6rem"
        bg="bg.wa.light"
        width="full"
        minH="100vh"
        height="auto"
        position="relative"
      >
        <Box px={{ base: "250", md: "500" }} pb="100" flex="1">
          <ReservationDetails
            orderId={displayOrderId}
            isPublic={false}
            hidePaymentRetry
            maxW="100%"
          />
        </Box>
        <Flex
          position="sticky"
          bottom="0"
          py="300"
          px={{ base: "250", md: "500" }}
          bg="white"
          borderTop="1px solid"
          borderColor="border.light"
          justifyContent="center"
          zIndex="10"
        >
          <Button
            mode="light"
            visual="primary"
            size="md"
            Icon={OpenNewWindow}
            onClick={handleOpenOrderPage}
            w="full"
          >
            {t("OPEN_ORDER_PAGE")}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
